import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import DialogBox from '@/components/DialogBox';
import { useToastContext } from '@/contexts/toastContext';
import useApiSubmit from '@/hooks/useApiSubmit';
import jobServices, { DeleteJobParams } from '@/services/jobs';
import { Job } from '@/types/api';
import { Paths } from '@/types/routes';
import JobResumeComponent from './JobResume.component';

type JobResumeProps = {
  job?: Job;
  hideDateInfos?: boolean;
  className?: string;
};

const JobResume = ({ job, hideDateInfos = false, ...props }: JobResumeProps): JSX.Element => {
  const navigate = useNavigate();
  const [openDialog, setOpenDialog] = useState<boolean>(false);
  const toast = useToastContext();

  const deleteJobMutation = useApiSubmit<any, DeleteJobParams>(jobServices.deleteJob);

  const handleClickOnDelete = (): void => {
    setOpenDialog(true);
  };

  const onDeleteJob = async (): Promise<void> => {
    if (!job) return;

    try {
      await deleteJobMutation.mutateAsync({ id: job.id });
      setOpenDialog(false);
      navigate(Paths.JOBS);
      toast.showSuccessFeedback('The job has been deleted.');
    } catch (err) {
      toast.showErrorFeedback('There was a problem deleting the job.');
    }
  };

  return (
    <>
      <JobResumeComponent
        hideDateInfos={hideDateInfos}
        openDeleteDialog={handleClickOnDelete}
        job={job}
        {...props}
      />
      <DialogBox
        data-testid="delete-job-dialog"
        isOpen={openDialog}
        onCancelHandler={() => setOpenDialog(false)}
        onConfirmHandler={() => onDeleteJob()}
      />
    </>
  );
};

export default JobResume;
